export default __webpack_public_path__ + "static/media/turkey_white_female.37fe6363.png";